import { render } from "./SearchElement.vue?vue&type=template&id=40b4e01c&scoped=true"
import script from "./SearchElement.vue?vue&type=script&lang=js"
export * from "./SearchElement.vue?vue&type=script&lang=js"

import "./SearchElement.vue?vue&type=style&index=0&id=40b4e01c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b4e01c"]])

export default __exports__